import { RouterView } from "vue-router";
import { ETAB_ROUTES } from "@etab/config";
import ProfilePage from "./Profile.page.vue";
import ProfilePhotoPage from "./ProfilePhoto.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.account.profile.root.path,
      name: ETAB_ROUTES.account.profile.root.name,
      redirect: { name: ETAB_ROUTES.account.profile.info.name },
      component: RouterView,
      children: [
        {
          path: ETAB_ROUTES.account.profile.info.path,
          name: ETAB_ROUTES.account.profile.info.name,
          component: ProfilePage,
        },
        {
          path: ETAB_ROUTES.account.profile.cropper.path,
          name: ETAB_ROUTES.account.profile.cropper.name,
          component: ProfilePhotoPage,
        },
      ],
    },
  ];
}
